<template>
  <div>
    <el-tabs style="margin-top: 3px" type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="puiTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{pui.puiNo}}</td>
            <td class="tableLabel">申请人：</td>
            <td>{{pui.creatorName}}</td>
            <td class="tableLabel">申请类型：</td>
            <td> {{pui.applyTypeName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">产品名称：</td>
            <td>{{pui.productName}}</td>
            <td class="tableLabel">产品型号：</td>
            <td>{{pui.productModel}}</td>
            <td class="tableLabel">预估受影响总量：</td>
            <td>{{pui.affectQuantity}}</td>
          </tr>
          <tr>
            <td class="tableLabel">批次和生产日期：</td>
            <td colspan="5">{{pui.productionDateAndBatch}}</td>
          </tr>
          <tr>
            <td class="tableLabel">缺陷情况描述：</td>
            <td colspan="5">{{pui.defectDesc}}</td>
          </tr>
          <tr>
            <td class="tableLabel">缺陷可能导致的后果：</td>
            <td colspan="5">{{pui.defectResult}}</td>
          </tr>
          <tr>
            <td class="tableLabel">生产缺陷的原因：</td>
            <td colspan="5">{{pui.defectReason}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="second" label="组织会议">
        <table
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">所涉及的产品：</td>
            <td>
              <el-input v-model="pui.involvedProducts" disabled type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">问题描述：</td>
            <td>
              <el-input v-model="pui.problemDesc" disabled type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">根本原因：</td>
            <td>
              <el-input v-model="pui.rootCause" disabled type="textarea" placeholder="请输入"/>
            </td>
          </tr>
          <td class="tableLabel">是否强制：</td>
          <td>
            <el-radio-group v-model="pui.isCoerce" disabled>
              <el-radio :label="true">强制</el-radio>
              <el-radio :label="false">不强制</el-radio>
            </el-radio-group>
          </td>
        </table>
        <div style="margin:5px 5px;font-size: 14px">
          校正措施:
        </div>
        <table
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">客户处：</td>
            <td>
              <el-input v-model="pui.customerGoods" disabled type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">新时达工厂处：</td>
            <td>
              <el-input v-model="pui.factoryGoods" disabled type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">供应商处：</td>
            <td>
              <el-input v-model="pui.supplierGoods" disabled type="textarea" placeholder="请输入"/>
            </td>
          </tr>
        </table>
        <div style="margin:5px 5px;font-size: 14px">
          相关部门评审意见:
        </div>
        <el-table
            ref="table"
            :data="pui.puiProcessList">
          <el-table-column type="selection" align="center" width="55"/>
          <el-table-column prop="departmentName" align="center" label="部门"/>
          <el-table-column prop="approverName" align="center" label="处理人"/>
          <el-table-column prop="releaseTime" align="center" label="下达时间"/>
          <el-table-column prop="approveResult" align="center" label="处理意见"/>
          <el-table-column prop="approveTime" align="center" label="处理时间"/>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 12px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="pui.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import constants from "@/util/constants.js";
  import DeliveryTypeSelect from "@/views/afterSalesManagement/Replacement/DeliveryTypeSelect";
  import MaterialCSSelect from "@/views/afterSalesManagement/Replacement/MaterialCSSelect";
  import DeliveryBillPrintOther from "@/views/afterSalesManagement/Replacement/DeliveryBillPrintOther";
  import ReplacementCopyEdit from "@/views/afterSalesManagement/Replacement/ReplacementCopyEdit";
  export default {
    name:"",
    components:{HandleDetail},
    data() {
      return {
        constant,
        constants,
        applyTypes:constant.toSelect(constant.applyType),
        addSaleLoading:false,
        deliveryLoading:false,
        imgUrls: [],
        billId:"",
        billType:"31",
        pkid:"",
        pui: {
          pkid: "",
          puiNo: "",
          applyType: "",
          applicantId: "",
          applicantName: "",
          applicantDepartmentName: "",//申请部门
          affectQuantity: "",
          productionDateAndBatch: "",
          defectDesc: "",
          defectResult: "",
          defectReason: "",
          applyTypeName: "",
          puiProcessList:[],
          attachments:[],
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.pui={};
    },
    methods:{
      getData() {
        this.$http.get("basic",`pui/${this.billId}`).then((res)=>{
          this.pui = res;
          this.pui.attachments.forEach(row=>{
            if(row.filePath.includes("common")) {
              row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
              this.imgUrls.push(row.imgUrl);
            }else {
              row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
              this.imgUrls.push(row.imgUrl);
            }
          });
        }).catch(()=>{
        });
      },
      // 物料选择对话框
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      getDetails(row,index) {
        this.pui.details[index].materialId = row.id;
        this.pui.details[index].materialDesc = row.name;
        this.pui.details[index].materialNo = row.no;
      },
      downLoad(row) {
        if(row.filePath.includes("common")) {
          let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }else {
          let a = document.createElement("a");
          a.href = "http://emes.stepelectric.com" + row.filePath;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
table.puiTable {
  font-family: verdana,arial,sans-serif;
  font-size:12px;
  color:#333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.puiTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}
table.puiTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.tableLabel {
  width: 12%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
